var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptodataTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.375,
    height: 18.532,
    viewBox: "0 0 22.375 18.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cryptodata-twitter",
    transform: "translate(0.268 -44.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3703",
    "data-name": "Group 3703",
    transform: "translate(0 44.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17766",
    "data-name": "Path 17766",
    d: "M21.651,46.779a.777.777,0,0,0-.672-.271,4.928,4.928,0,0,0,.257-.643.773.773,0,0,0-1.131-.9,7.549,7.549,0,0,1-2.011.83,4.936,4.936,0,0,0-8.21,3.693q0,.046,0,.091a11.138,11.138,0,0,1-7.1-3.98.773.773,0,0,0-1.267.1,4.942,4.942,0,0,0-.151,4.685.765.765,0,0,0-.163.07.777.777,0,0,0-.388.652c0,.023,0,.047,0,.071a4.965,4.965,0,0,0,1.633,3.664.776.776,0,0,0-.137.724,4.955,4.955,0,0,0,2.631,2.973,7.6,7.6,0,0,1-3.176.69,7.7,7.7,0,0,1-.9-.053.773.773,0,0,0-.508,1.418,12.569,12.569,0,0,0,6.8,1.992,12.1,12.1,0,0,0,9.371-4.12,13.032,13.032,0,0,0,3.243-8.494q0-.081,0-.162a9.19,9.19,0,0,0,1.935-2.1A.777.777,0,0,0,21.651,46.779Zm-2.586,2.47a.435.435,0,0,0-.173.361c0,.119.005.24.005.359a12.151,12.151,0,0,1-3.026,7.919,11.25,11.25,0,0,1-8.719,3.825,11.7,11.7,0,0,1-5.977-1.638c.2.013.393.02.59.02a8.438,8.438,0,0,0,4.486-1.281.435.435,0,0,0-.135-.793A4.08,4.08,0,0,1,3.192,55.45c.073.011.145.02.218.027a.435.435,0,0,0,.266-.806,4.094,4.094,0,0,1-1.989-3.387,4.267,4.267,0,0,0,.526.223.435.435,0,0,0,.474-.693A4.072,4.072,0,0,1,2.2,46.258,12,12,0,0,0,10.317,50.5a.435.435,0,0,0,.469-.488,4.171,4.171,0,0,1-.033-.526,4.067,4.067,0,0,1,6.911-2.905.435.435,0,0,0,.4.114,8.41,8.41,0,0,0,2.259-.852,4.023,4.023,0,0,1-.738,1.206.435.435,0,0,0,.447.706c.257-.074.511-.161.76-.26A8.307,8.307,0,0,1,19.065,49.25Z",
    transform: "translate(0 -44.552)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptodataTwitter);
export default __webpack_public_path__ + "static/media/cryptodata-twitter.0b9811aae10d05913447b4b53c34982b.svg";
export { ForwardRef as ReactComponent };